/* Tab media — click-to-play facade for YouTube / Vimeo
   Keeps third-party player scripts out of the page until the
   visitor actually asks for the video. */

(function () {
  'use strict';

  function buildEmbedUrl(el) {
    var type = el.dataset.videoType;
    var id = el.dataset.videoId;
    var loop = el.dataset.videoLoop === '1';
    var controls = el.dataset.videoControls === '1';

    if (!id) return null;

    if (type === 'vimeo') {
      var vimeo =
        'https://player.vimeo.com/video/' +
        encodeURIComponent(id) +
        '?autoplay=1&muted=1&playsinline=1';
      if (loop) vimeo += '&loop=1';
      if (!controls) vimeo += '&controls=0';
      return vimeo;
    }

    var yt =
      'https://www.youtube.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&mute=1&playsinline=1&rel=0';
    if (loop) yt += '&loop=1&playlist=' + encodeURIComponent(id);
    if (!controls) yt += '&controls=0';
    return yt;
  }

  function activate(el) {
    if (el.dataset.videoLoaded === 'true') return;

    var src = buildEmbedUrl(el);
    if (!src) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('class', 'tab-media__iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', el.getAttribute('data-video-title') || 'Video');
    iframe.setAttribute('loading', 'lazy');

    el.innerHTML = '';
    el.appendChild(iframe);
    el.dataset.videoLoaded = 'true';
  }

  function bind(root) {
    var facades = (root || document).querySelectorAll('[data-tab-video-facade]:not([data-video-bound])');

    facades.forEach(function (el) {
      el.dataset.videoBound = 'true';

      el.addEventListener('click', function () {
        activate(el);
      });

      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate(el);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bind(document);
  });

  /* Re-bind after a variant change or section re-render swaps the tab markup. */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });

  document.addEventListener('product-tab:updated', function (event) {
    bind(event.target);
  });

  /* Pause any playing embed when its tab is closed, so audio does not
     keep running behind a collapsed accordion. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-collapsible]');
    if (!toggle) return;

    window.setTimeout(function () {
      document.querySelectorAll('.tab-content:not(.is-active) [data-tab-video-facade][data-video-loaded="true"] iframe').forEach(
        function (iframe) {
          var src = iframe.getAttribute('src');
          iframe.setAttribute('src', src);
        }
      );
    }, 50);
  });
})();
